import React, { useState, useEffect } from "react";
import { BASE_URL } from "./axios";
import axios from "axios";
import { AddwithWhiteCircle, DropdownArrow, SearchBig, UpdatePencil, PDFIcon, DeleteDustbin, Attachment, Eye, Documentation } from "../../utils/ReusableSVGs";
import { Modal } from 'react-bootstrap';
import Select from "react-select";
import { ViewEmployeeList } from "../../utils/ReusableFunctions";

import { handleErrorToast } from "../../utils/ReusableFunctions";
import { toast, ToastContainer } from 'react-toastify';
import { StructureFlyovertable } from "./StructureTable";
import AllTask from "./AllTask"
import { EditDepartment, DepartmentDelete, AddTask, SubTaskModal, AddSubtask, } from "./AllProjectdetailsmodal";



const DepartmentTask = ({ projectID, departmentId, getDepartmentList, departmentlist }) => {
    const [toggleStatechange, setToggleStatechange] = useState(1);
    const [clientExists, setClientExists] = useState(false);


    const [allActivity, setAllActivity] = useState([]);
    const [alltask, setAllTask] = useState([]);
    console.log({ departmentId });



    const fetchTask = async (id) => {
        try {

            const res = await axios.get(`${BASE_URL}/project_details/taskfilterbydep/${id}/`);
            // const res = await axios.get(`${BASE_URL}/project_details/taskfilterbydep/`);
            setAllTask(res.data);
        } catch (err) {

        }
    };



    // const [project, setProject] = useState([]);

    // const getProjectDetails = async () => {
    //     try {
    //         const ress = await axios.get(
    //             `${BASE_URL}/detail-design/projectupdate/${projectID}/`
    //         );
    //         setProject(ress.data);
    //     } catch (err) { }
    // };

    // useEffect(() => {
    //     // getReviewteam();
    //     getProjectDetails();
    //     // fetchActivity(departmentId?.id);
    // }, []);

    useEffect(() => {
        console.log("departmentDataaa", departmentId);
        if (departmentId) {

            fetchTask(departmentId)
        }
    }, [departmentId]);



    console.log(departmentId, 'departemtn data')

    return (
        <>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            <div className="attendance-box">
                <div className="info-box-div-without-bg">
                    <div className="info-box-div-bg">


                        <div className="personal-detail" style={{ width: '100%' }}>
                            <div>

                                <div className="jd-heading-bottom-light-blue"></div>
                                <div className="info-box-div">
                                    <div className="jd-heading-outer heading-bg-color-white" style={{ marginBottom: "10px", marginTop: '10px', width: '100%' }}>
                                        <div className="jd-heading-outer-flex" style={{ alignItems: 'center' }}>
                                            <div>
                                                <h3 className="jd-heading-main font-weight600  font-size-heading">
                                                    Task List:
                                                </h3>
                                            </div>
                                            <div>
                                                <AddTask
                                                    projectID={projectID}
                                                    department_name={departmentId}
                                                    tasklist={alltask}
                                                    getTaskList={fetchTask}
                                                />
                                            </div>
                                        </div>
                                    </div>



                                </div>
                                <div className="jd-heading-bottom-light-blue"></div>
                                <div className="department-div">

                                    {<div className="bloc-tabss wfm-without-margin">
                                        {alltask.map((activity, index) => (
                                            <button
                                                key={activity.id}
                                                className={
                                                    toggleStatechange === index + 1
                                                        ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-active-tabs"
                                                        : "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponents-tabs-color"
                                                }
                                                onClick={() => setToggleStatechange(index + 1)}
                                            >
                                                {activity.task_name}
                                            </button>
                                        ))}


                                    </div>}
                                    <div className="jd-heading-bottom-light-blue"></div>
                                </div>

                                <>

                                    {alltask?.map((dept, index) => {
                                        console.log(dept, 'singledpt')
                                        return (<>
                                            {toggleStatechange === index + 1 ?
                                                <AllTask projectId={projectID} TaskData={dept} getDepartmentList={getDepartmentList} projectID={projectID}
                                                    department_name={departmentId}
                                                    tasklist={alltask}
                                                    getTaskList={fetchTask} />
                                                : null}
                                        </>)

                                    }

                                    )}

                                </>
                            </div>


                        </div>
                    </div>
                </div>
            </div>

        </>
    );
};

export default DepartmentTask;
